
























































































import VueOptions from '@utils/VueOptions'
import TitlePatternUtility from '@utils/TitlePatternUtility'
import TagBar from '@ui/TagBar'
import SponsorSetList from '@ui/SponsorSet/SponsorSetList'

settings =
  name: 'FeedCardCenter'

  vue:
    props: ['item', 'activationPlan', 'nearby_poi', 'options']

    components: {
      TagBar,
      SponsorSetList,
    }

    computed:
      title: ->
        TitlePatternUtility.formatListingTitle @item

      audienceListingTypes: -> @compact(@item?.types || [])
      audienceListingTypesFilter: -> @compact(@options.target?.listing?.types || [])

      activityTags: -> @compact(@item?.activity_tags || [])
      activityTagsFilter: -> @compact(@options.target?.listing?.activity_tags || [])

      typesAndActivityTags: -> @compact([...new Set([@item.primary_type, ...@audienceListingTypes, ...@activityTags])])
      typesAndActivityTagsFilter: -> @compact([...@audienceListingTypesFilter, ...@activityTagsFilter].filter(Boolean))

      personaProfile: -> @item?.persona_profile || {}
      personaSegmentsFilter: -> @options.target?.audience?.persona_segments || []

      reach: -> @item?.reach

      nearbyPOITagsFilter: -> @compact(@options.target?.geo?.poi_list || [])

      catex: -> @item?.catex || {}
      campaignCategories: -> @compact(@options.campaign?.brand_info?.category_tags || [])
      campaignDomain: -> @$options.filters.formatDomain(@options.campaign?.brand_info?.domain)

      hasSponsorSet: -> !!@item.sponsor_set?.length

      unavailableCategories: ->
        { formatDomain, formatTitle } = @$options.filters
        @campaignCategories
          .filter((category) =>
            return false unless @catex[category]
            sponsors = @catex[category].sponsors || []
            domains = sponsors.map((s) => formatDomain(s.domain))
            @campaignDomain not in domains
          )
          .map((category) =>
            id: category
            name: category
            tooltip: formatTitle(category)
            icon: { name: 'banned' }
          )

      sortTags: ->
        tags = []
        for sort in @options.sort || [] when sort.type not in ['audience']
          value = parseFloat @resolveDotPath(@item, sort.field)
          continue unless value
          percentage = @$options.filters.formatNumber value * 100
          tags.push {
            id: sort.field
            name: "#{sort.label} #{percentage}%"
          }
        tags

      audienceTags: -> @item?.audience_tags || []
      audienceFilter: -> @options.target?.audience?.types || []
      audienceIndex: ->
        return []
        # (@ctxEventSet(@item).audience_index || []).map((index) =>
        #   {
        #     id: index[0],
        #     name: index[0],
        #     tooltip: "#{index[1]}"
        #   }
        # )

      scoreType: ->
        @options.target?.audience.score_type || 'score'

      isOmnichannel: ->
        @activationPlan?.line_items_info?[0]?.item?.pricing_model is 'omnichannel'

      omnichannelTags: ->
        { formatOmnichannelType } = @$options.filters
        tags = []
        if @item?.physical_signs?.enabled
          tags.push { key: 'sheet', label: formatOmnichannelType('sheet') } if @item.physical_signs.sheet?.enabled
          tags.push { key: 'popup_banner', label: formatOmnichannelType('popup_banner') } if @item.physical_signs.popup_banner?.enabled
        for type in @item?.omnichannel_types || []
          tags.push { key: type, label: formatOmnichannelType(type) }
        tags

      highlightedOmnichannelTags: ->
        physicalSigns = @options.target?.physical_signs || {}
        omnichannel = @options.target?.omnichannel || {}
        tags = []
        tags.push 'sheet' if physicalSigns.sheet
        tags.push 'popup_banner' if physicalSigns.popup_banner
        tags.push 'email' if omnichannel.digital?.email
        tags.push 'sms' if omnichannel.digital?.sms
        tags.push 'push' if omnichannel.digital?.push
        tags.push 'instagram' if omnichannel.social?.instagram
        tags.push 'tiktok' if omnichannel.social?.tiktok
        tags.push 'twitter' if omnichannel.social?.twitter
        tags.push 'facebook' if omnichannel.social?.facebook
        tags

      personaTags: ->
        { formatPersonaSegment, formatPersonaScore } = @$options.filters
        tags = []
        for personaSegment in @personaSegmentsFilter
          profile = @personaProfile[personaSegment]
          score = profile?[@scoreType]
          continue unless score
          label = "#{formatPersonaSegment(personaSegment)} #{formatPersonaScore(score)}"
          iconName = 'under-indexed'
          iconName = 'over-indexed' if score >= 100
          tags.push { key: personaSegment, label, icon: { name: iconName }, score }
        tags.sort((a, b) => b.score - a.score)
        tags

      highlightedPersonaTags: ->
        tags = []
        for personaSegment in @personaSegmentsFilter
          profile = @personaProfile[personaSegment]
          score = profile?[@scoreType]
          continue unless score >= 100
          tags.push { key: personaSegment, score }
        tags.sort((a, b) => b.score - a.score)
        tags.map((tag) => tag.key)

      eventNearbyPOIs: ->
        list = []
        return list unless @nearby_poi
        for name, poi of @nearby_poi.poi_list
          closestLocation = poi.locations[0]
          list.push { id: poi.id, name: "#{name} - #{closestLocation.distance} mi." }
        list

      omnichannelInfo: ->
        list = []
        if @item?.omnichannel?.info
          for groupType, group of @item.omnichannel.info when group?.enabled
            for type, info of group when info?.enabled
              list.push { type, ...info }
        list

      tagOptionsForListingCategories: ->
        {
          bar: {
            theme: 'card',
            max: 4,
            # icon: {
            #   name: 'listing-category'
            # }
          },
          tag: {
            theme: 'card',
            format: 'formatListingCategory'
          }
        }

      tagOptionsForListingTypes: ->
        {
          bar: {
            theme: 'card',
            max: 4,
            # icon: {
            #   name: 'listing-type'
            # }
          },
          tag: {
            theme: 'card',
            format: 'formatListingType',
            maxLength: 12
          }
        }

      tagOptionsForListingAudience: ->
        {
          bar: {
            theme: 'card',
            max: 4,
            # icon: {
            #   name: 'listing-audience'
            # }
          },
          tag: {
            theme: 'card',
            maxLength: 12
          }
        }

      tagOptionsForOmnichannel: ->
        bar:
          theme: 'card'
          max: 4
          # icon:
          #   name: 'omnichannel'
        tag:
          theme: 'card'
          maxLength: 12

      tagOptionsForPersona: ->
        bar:
          theme: 'card'
          max: 4
          # icon:
          #   name: 'persona'
        tag:
          theme: 'card'
          maxLength: 24

      tagOptionsForNearbyPOIs: ->
        {
          bar: {
            theme: 'card',
            max: 4,
          },
          tag: {
            theme: 'card',
            maxLength: 12
          }
        }

      tagOptionsForUnavailableCategories: ->
        {
          bar: {
            theme: 'danger',
            max: 4,
          },
          tag: {
            theme: 'danger',
            maxLength: 12
          }
        }

      tagOptionsForSortTags: ->
        {
          bar: {
            theme: 'card',
            max: 4,
          },
          tag: {
            theme: 'card',
            maxLength: 12
          }
        }

export default VueOptions.vue settings
